const versionMateEl = document.querySelector('meta[name="iterative-version"]');
const assetsUrlMateEL = document.querySelector('meta[name="assets-url"]');
const version = versionMateEl?versionMateEl.getAttribute('content'):'';
const assetsUrl = assetsUrlMateEL?assetsUrlMateEL.getAttribute('content'):'';

const syncLoadSource = (link) => {
	return new Promise((resolve, reject) => {
		try{
			const version = kte.version;
			const assetsUrl = kte.assetsUrl;
			const isCss = link.endsWith('.css');
			const documentTmpEl = document.createElement(isCss?'link':'script');
			let _vlink = `${link}?v=${version || '1.0'}`;
			if(assetsUrl){
				if(!link.startsWith('http') || !link.startsWith('https')){
					if(link.includes('/dist/')){
						_vlink = `${assetsUrl}${version}${link}`;
					}else{
						_vlink = `${assetsUrl}${link}`;
					}
				}
			}
			if(isCss){
				documentTmpEl.rel = 'stylesheet';
				documentTmpEl.href = kte.cleanUrl(_vlink);
			}else{
				documentTmpEl.async = false;
				documentTmpEl.src = kte.cleanUrl(_vlink);
			}
			documentTmpEl.onload = function(){
				setTimeout(() => {
					resolve(link);
				},70)
			}
			const delayLoad = () => {
				if(document.body === null){
					setTimeout(() => {
						delayLoad();
					},60);
					return;
				}
				document.body.appendChild(documentTmpEl);
			}
			delayLoad();
		}catch(err){
			reject(err);
		}
	})
}

window.kte = {
	_globalLoadingState: false,
	_loadingWillState: false,
	_preLoadingTick: null,
	_lazyLoadPath: [],
	_lazyLoadComplete: [],
	_swiperObj: {},
	version: version,
	assetsUrl: assetsUrl,
	cleanUrl: (url)  => {
		if(url.startsWith('http://') || url.startsWith('https://')){
			const { hash, search, origin, pathname } = new URL(url);
			const newUrl = [
				origin,
				pathname.replace(/\/+/g, '/'),
				search,
				hash
			];
			return newUrl.filter(v => v).join('');
		}
		return url;
	},
	getURLvar: (key = null, value = null) => {
		const query = location.search.slice(1).split('&').map(v => v.split('=')).reduce((p,n) => { return {...p,[n[0]]:n[1]} },{});
		if(key === null){
			return query;
		}
		return query[key] || value;
	},
	visibleWatch: (elObj, fn, options = {}) => {
		if('IntersectionObserver' in window){
			const elObserver = new IntersectionObserver(function (entries, observer) {
				entries.forEach(function (entry) {
					const visible = entry.isIntersecting;
					const target = entry.target;
					fn && fn(visible, target, entry, () => {
						elObserver.unobserve(target);
					});
				});
			}, options);
			if(elObj){
				if(elObj instanceof Node){
					elObserver.observe(elObj);
				}else if(elObj instanceof NodeList){
					elObj.forEach(function (el) {
						elObserver.observe(el);
					});
				}else if(elObj instanceof jQuery){
					elObj.each(function(){
						elObserver.observe($(this)[0]);
					})
				}
			}
		}
	},
	globalLoading: () => {
		kte._loadingWillState = !kte._loadingWillState;
		if(kte._preLoadingTick){
			clearTimeout(kte._preLoadingTick);
		}
		kte._preLoadingTick = setTimeout(() => {
			if(kte._loadingWillState === kte._globalLoadingState){
				return;
			}
			kte._globalLoadingState = kte._loadingWillState;
			if(kte._loadingWillState){
				$('#global-loading').fadeIn();
			}else{
				$('#global-loading').fadeOut();
			}
		},120);
	},
	globalTip: (message, type = 'success', closeTime = 2000) => {
		if(!message){
			return false;
		}
		$('.global-tip').remove();
		const html = `<div class="global-tip">
			<div class="content">
				<i class="tip-icon tip-icon-${type}"></i>
				<div>${message}</div>
			</div>
		</div>`;
		$('body').append(html);
		setTimeout(() => {
			$('.global-tip').remove();
		}, closeTime);
	},
	toggleCateLayer: () => {
		const cateLayerOb = $('#cate-layer');
		const render = cateLayerOb.attr('data-render') || null;
		if(!render){
			kte.globalLoading();
			kte.lazyLoad('/static/catalog/theme/kte-m/dist/css/part/cate_layer.css').then(() => {
				kte.globalLoading();
				cateLayerOb.load('index.php?route=custom/site/cateLayer', function(response, status, xhr){
					if(xhr.status == 200){
						cateLayerOb.attr('data-render',1);
						cateLayerOb.removeClass('hide');
						setTimeout(() => {
							cateLayerOb.addClass('cate-layer-open');
							cateLayerOb.css('height', window.innerHeight);
							$('body').css('overflow','hidden');
						},60);
					}
				});
			})
			return;
		}
		if(cateLayerOb.hasClass('cate-layer-open')){
			cateLayerOb.removeClass('cate-layer-open');
			$('body').css('overflow','auto');
		}else{
			cateLayerOb.addClass('cate-layer-open');
			cateLayerOb.css('height', window.innerHeight);
			$('body').css('overflow','hidden');
		}
	},
	socialShare: () => {
		kte.globalLoading();
		kte.lazyLoad('/static/catalog/theme/kte-m/dist/css/part/share-popup.css').then(() => {
			const randomPopupId = Math.ceil(Math.random() * 999);
			const randomClass = `share-popup-${randomPopupId}`;
			const el = `<div class="kte-popop share-popup ${randomClass}"></div>`;
			$('body').append(el);
			const image = $('meta[property="og:image"]').attr('content') || '';
			const title = $('title').text() || '';
			$(`.${randomClass}`).load(`index.php?route=custom/site/share&media=${encodeURIComponent(image)}&via=${encodeURIComponent(title)}`,function(response, status, xhr){
				kte.globalLoading();
				if(xhr.status != 200){
					return false;
				}
				$(this).addClass('kte-popop-show');
				const _closeSharePopup = () => {
					$(`.${randomClass}`).removeClass('kte-popop-show');
					setTimeout(() => {
						$(`.${randomClass}`).off('click').remove();
					},2000);
				}
				$(this).on('click',function(){
					_closeSharePopup();
				}).on('click','.close-btn',function(){
					_closeSharePopup();
				}).on('click','.content',function(event){
					event.stopPropagation();
				}).on('click','.share-source-list .item',function(event){
					event.preventDefault();
					const href = $(this).attr('href');
					if(href){
						window.open(href,'_blank','width=760, height=560');
					}
				});
			});
		})
	},
	lazyLoad: (link) => {
		if(kte._lazyLoadPath.includes(link)){
			return new Promise((resolve) => {
				const _intervalId = setInterval(() => {
					if(kte._lazyLoadComplete.includes(link)){
						clearInterval(_intervalId);
						resolve(true);
					}
				}, 70);
			});
		}
		kte._lazyLoadPath.push(link);
		return syncLoadSource(link).then(result => {
			kte._lazyLoadComplete.push(result);
			return result;
		}).catch(err => {
			return err;
		});
	},
	lazyLoadMulite: (links) => {
		return Promise.all(links.map(v => kte.lazyLoad(v)));
	},
	addCart: (productId, quantity = 1, showLoading = true, buyNow = 0) => {
		showLoading && kte.globalLoading();
		return new Promise((resolve, reject) => {
			$.ajax({
				url: 'index.php?route=checkout/cart/add',
				data: {
					product_id: productId, 
					quantity: quantity,
					isBuyNow: buyNow
				},
				method: 'POST',
				dataType: 'JSON'
			}).done(result => {
				showLoading && kte.globalLoading();
				if(!buyNow){
					const { total } = result;
					if(total){
						$('#top-cart-count').text(total);
					}
				}
				resolve(result);
			}).fail(error => {
				showLoading && kte.globalLoading();
				reject(error);
			});
		})
	},
	removeWishlist: (productId, showLoading = true) => {
		showLoading && kte.globalLoading();
		return new Promise((resolve, reject) => {
			$.ajax({
				url: 'index.php?route=account/wishlist/del',
				data: {product_id: productId},
				method: 'POST',
				dataType: 'JSON'
			}).done(result => {
				showLoading && kte.globalLoading();
				resolve(result);
			}).fail(error => {
				showLoading && kte.globalLoading();
				reject(error);
			});
		})
	},
	addWishlist: (productId, showLoading = true) => {
		showLoading && kte.globalLoading();
		return new Promise((resolve, reject) => {
			$.ajax({
				url: 'index.php?route=account/wishlist/add',
				data: {product_id: productId},
				method: 'POST',
				dataType: 'JSON'
			}).done(result => {
				showLoading && kte.globalLoading();
				resolve(result);
			}).fail(error => {
				showLoading && kte.globalLoading();
				reject(error);
			});
		})
	},
	ratingStartRender: () => {
		$('.rating-list').each(function(){
			const rating = $(this).attr('data-rating') || 0;
			const render = $(this).attr('data-render') || 0;
			if(!render){
				const starList = [];
				for(let i = 0; i < 5; i++){
					const difference = rating - i;
					const _class = difference>0?(difference>=1?'c-icon-start-full':'c-icon-start-half'):'c-icon-start';
					starList.push(`<i class="start-icon-of-png ${_class}" data-i="${difference}"></i>`);
				}
				$(this).html(starList.join('')).attr('data-render',1);
			}
		});
	},
	swiperInit: (setting = {}) => {
		const swiperContainer = $('div[data-swiper="1"]');
		if(swiperContainer.length > 0){
			const basePath = '/static/catalog/javascript/jquery/swiper/';
			return kte.lazyLoadMulite([
				`${basePath}css/swiper.min.css`,
				`${basePath}js/swiper.min.js`
			]).then(() => {
				return new Promise((resolve, reject) => {
					setTimeout(() => {
						const _initSwiper = [];
						swiperContainer.each(function(){
							const init = 	$(this).attr('data-init') || 0;
							if(init == 1){
								return;
							}
							$(this).attr('data-init',1);
							const loop = $(this).attr('data-loop') || null;
							const autoplay = $(this).attr('data-autoplay') || null;
							const pagination = $(this).attr('data-pagination') || null;
							const paginationCustomEl = $(this).attr('data-pagination-custom') || null;
							const effect = $(this).attr('data-effect') || null;
							const centeredSlides = $(this).attr('data-centered-slides') || null;
							const name = $(this).attr('data-name') || `swiper-${~~(Math.random() * 10000)}`;
	
							$(this).addClass('swiper-container').children().eq(0).addClass('swiper-wrapper').children().addClass('swiper-slide');
	
							const fixSwiperLoopImgHdLoad = (imgSlide) => {
								imgSlide.each(function(){
									const src = $(this).attr('src');
									const srcHd = $(this).attr('data-src');
									if(srcHd && src !== srcHd){
										$(this).addClass('img-lazy');
										kte.lazyLoadImg();
									}
								});
							}
							
							const swiperSetting = {
								loop: loop == 1,
								onInit: (swiper) => {
									if(setting && setting.onInit){
										setting.onInit(swiper, name);
									}
									const imgSlide = $(this).find('.swiper-slide img');
									if(imgSlide.length){
										fixSwiperLoopImgHdLoad(imgSlide);
									}
								},
								onSlideChangeEnd: (swiper) => {
									if(setting && setting.onSlideChangeEnd){
										setting.onSlideChangeEnd(swiper, name);
									}
								},
								onDestroy: (swiper) => {
									if(setting && setting.onDestroy){
										setting.onDestroy(swiper, name);
									}
								}
							};
							if(autoplay > 0){
								swiperSetting['autoplay'] = autoplay;
							}
	
							if(paginationCustomEl){
								swiperSetting.pagination = paginationCustomEl
							}else{
								if(pagination){
									$(this).append(`<div class="pagination auto-swiper-pagination auto-swiper-pagination-${pagination}"></div>`);
									swiperSetting.pagination = $(this).children('.pagination')[0];
								}
								if(pagination == 1){
									swiperSetting.paginationType = 'fraction';
									swiperSetting.paginationFractionRender = (swiper, currentClassName, totalClassName) => {
										if(pagination){
											return `<div class="flex-center page-number">
												<div class="${currentClassName}"></div>&nbsp;/&nbsp;<div class="${totalClassName}"></div>
											</div>`;
										}
									}
								}
							}

							if(centeredSlides){
								swiperSetting['centeredSlides'] = true;
							}

							if(effect){
								swiperSetting['effect'] = effect;
								if(effect === 'coverflow'){
									swiperSetting.coverflow = {
										slideShadows: false
									};
									const _elData = $(this).data();
									for(let key in _elData){
										if(key.startsWith('coverflow')){
											const _key = key.replace('coverflow','').toLowerCase();
											swiperSetting.coverflow[_key] = _elData[key];
										}
									}
								}
							}

							const swiper = new Swiper($(this)[0],swiperSetting);
							kte._swiperObj[name] = swiper;
							$(this).attr('data-name',name);
							_initSwiper.push(swiper);
						});
						resolve(_initSwiper);
					})
				})
			});
		}
		return Promise.resolve([]);
	},
	lazyLoadImg: () => {
		const lazyloadImages = document.querySelectorAll('.img-lazy');
		kte.visibleWatch(lazyloadImages,function(visible, target, entry, unobserve){
			if(visible){
				unobserve();
				target.classList.remove('img-lazy');
				if(target.dataset.src){
					const tmpImg = new Image();
					tmpImg.src = target.dataset.src;
					tmpImg.onload = function() {
						target.src = target.dataset.src;
					}
					tmpImg.onerror = function() {
						target.src = target.dataset.src;
						console.log('load err:'+target.dataset.src);
					}
				}
			}
		})
	}
}